// SVG, PNG
import discord from 'Assets/images/discord.svg';
import slack from 'Assets/images/slack.svg';
import unityIntercom from 'Assets/images/unityIntercom.svg';
import multiview from 'Assets/images/multiview.png';
import programFeed from 'Assets/images/program_feed.png';
import dashboardIcon from 'Assets/images/gauge.png';
import linkIcon from 'Assets/images/link.png';

export const ProjectIntegrationsPageSideNavType = {
    ADD_INTEGRATIONS: {
        title: 'Add Integrations',
        subTitle: 'Add integrations for this project.',
    },
    EDIT_INTEGRATIONS: {
        title: 'Edit the Integration',
        subTitle: "Edit selected integration's title & url.",
    },
};

export const IntegrationDeleteModalTypes = {
    discord: {
        type: 'discord',
        title: 'Delete Discord?',
        body: `Are you sure you want to delete this discord channel?`,
    },
    slack: {
        type: 'slack',
        title: 'Delete Slack?',
        body: `Are you sure you want to delete this slack channel?`,
    },
    unity_intercom: {
        type: 'unity_intercom',
        title: 'Delete Unity Intercom?',
        body: `Are you sure you want to delete this unity intercom channel?`,
    },
    multi_view: {
        type: 'multi_view',
        title: 'Delete Multiview?',
        body: `Are you sure you want to delete this multiview link?`,
    },
    program_feed: {
        type: 'program_feed',
        title: 'Delete Program Feed?',
        body: `Are you sure you want to delete this program feed link?`,
    },
    dashboard: {
        type: 'dashboard',
        title: 'Delete Dashboard Link?',
        body: `Are you sure you want to delete this dashboard link?`,
    },
    link: {
        type: 'link',
        title: 'Delete Wildcard Link?',
        body: `Are you sure you want to delete this wildcard link?`,
    },
};

export const OrgIntegrationPageSideNavType = {
    ADD_INTEGRATION: {
        title: 'Add Integration',
        subTitle: 'Add a default integration for this organization.',
    },
    EDIT_INTEGRATION: {
        title: 'Edit Integration',
        subTitle: "Edit the organization integration's setting.",
    },
};

export const OrgIntegrations = {
    discord: {
        type: 'discord',
        title: 'Discord',
        name: 'Discord',
        description: 'Everything you need for work, all in one place.',
        image: discord,
        url: "",
        is_copy_to_projects: false,
    },
    unity_intercom: {
        type: 'unity_intercom',
        title: 'Unity Intercom',
        name: 'Unity Intercom',
        description: 'Plan, track, and release great software.',
        image: unityIntercom,
        url: "",
        is_copy_to_projects: false,
    },
    slack: {
        type: 'slack',
        title: 'Slack',
        name: 'Slack',
        description: 'Send notifications to channels and create projects.',
        image: slack,
        url: "",
        is_copy_to_projects: false,
    },
    multi_view: {
        type: 'multi_view',
        title: 'Multiview',
        name: 'Multiview',
        image: multiview,
        description: 'View multiple cameras, program and preview',
        url: "",
        is_copy_to_projects: false,
    },
    program_feed: {
        type: 'program_feed',
        title: 'Program Feed',
        name: 'Program Feed',
        image: programFeed,
        description: 'View program feed fullscreen.',
        url: "",
        is_copy_to_projects: false,
    },
    dashboard: {
        type: 'dashboard',
        title: 'Dashboard',
        name: 'Dashboard',
        image: dashboardIcon,
        description: 'View dashboard screen',
        url: "",
        is_copy_to_projects: false,
    },
    link: {
        type: 'link',
        title: 'Link',
        name: 'Link',
        image: linkIcon,
        description: 'Wildcard Link',
        url: "",
        is_copy_to_projects: false,
    },
};
